import { asPercent } from "@silo/utils";
import { Align, Breakdown } from "./components";
import { Percent, PositionReward } from "@silo/types";

interface BreakdownDebtProps {
  className?: string;
  debtBaseApr: Percent;
  debtRewards: PositionReward[];
  isDebtAprFixed: boolean;
  align: Align;
}

export function BreakdownDebt({
  className,
  debtBaseApr,
  debtRewards,
  align,
  isDebtAprFixed,
}: BreakdownDebtProps): JSX.Element {
  return (
    <Breakdown.Root className={className} align={align}>
      <Breakdown.Item>
        <Breakdown.ItemValue className="text-red-400">
          {asPercent(debtBaseApr)}
        </Breakdown.ItemValue>

        <Breakdown.ItemLabel>
          {isDebtAprFixed ? "fixed " : ""}borrow APR (cost)
        </Breakdown.ItemLabel>
      </Breakdown.Item>

      {debtRewards.map((reward) => (
        <Breakdown.DebtRewardItem reward={reward} />
      ))}
    </Breakdown.Root>
  );
}
